interface PropParams {
    side: 'buy' | 'sell'
}

export function SideIcon(props: PropParams) {
    const color = props.side === 'buy' ? 'bg-green-400' : 'bg-red-400'
    return (
        <div className={`rounded-md p-0.5 text-neutral-800 w-10 text-center ${color}`}>{props.side}</div>
    )
}